import { customStyled } from "styles/theme"

export const InnerWrapper = customStyled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  height: "100%",
}))
